import Vue from 'vue'
import Contact from './Contact.vue'
import '@/assets/common/css/common.less'
import '@/plugins/fontsLoader'

Vue.config.productionTip = false

new Vue({
  render: (h) => h(Contact)
}).$mount('#Contact')
